// Firebase v10 初始化
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import firebaseConfig from './firebase';

let app;
let auth;
let db;

try {
  // 初始化 Firebase
  app = initializeApp(firebaseConfig);
  
  // 初始化 Firebase Authentication 和 Firestore
  auth = getAuth(app);
  db = getFirestore(app);
  
  console.log('Firebase 初始化成功');
} catch (error) {
  console.error('Firebase 初始化失敗:', error);
  
  // 顯示用戶友好的錯誤訊息
  const errorMessage = error.code === 'app/invalid-api-key' 
    ? 'Firebase API 金鑰無效，請檢查配置' 
    : error.code === 'app/app-deleted'
    ? 'Firebase 應用已被刪除，請重新創建'
    : `Firebase 初始化錯誤: ${error.message}`;
    
  // 在開發環境顯示詳細錯誤，在生產環境顯示簡化錯誤
  if (process.env.NODE_ENV === 'development') {
    alert(`開發環境錯誤: ${errorMessage}\n\n詳細信息: ${error}`);
  } else {
    alert('系統初始化失敗，請稍後重試或聯繫技術支援');
  }
  
  // 拋出錯誤，讓上層處理
  throw error;
}

export { auth, db };
export default app;
